import { render, staticRenderFns } from "./barcodeOXXO.vue?vue&type=template&id=5f41550c&scoped=true&"
import script from "./barcodeOXXO.vue?vue&type=script&lang=js&"
export * from "./barcodeOXXO.vue?vue&type=script&lang=js&"
import style0 from "./barcodeOXXO.vue?vue&type=style&index=0&id=5f41550c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f41550c",
  null
  
)

export default component.exports